/**
 * @fileoverview Player dashboard page
 *
 * Player dashboard page related components initialization
 */

import RecentResultsSection from './recent-results';
import ActivateWTNSection from './activate-wtn';
import ITFWTNSection from './itf-wtn';

const recentResultsSection = new RecentResultsSection();
const activateWTNSection = new ActivateWTNSection();
const itfWTNSection = new ITFWTNSection();

recentResultsSection.init();
activateWTNSection.init();
itfWTNSection.init();
